export default __webpack_public_path__ + "a2251ee00cfdda4261eb67ae2f469c89.png";